<template>
  <div class="d-flex align-center" :class="`background-auth${$vuetify.theme.dark ? '-dark' : ''}`" style="height: 100vh;">
    <v-card class="mx-auto text-left pa-8 bgPanel" :width="480" flat align="center" justify="center">
      <v-col class="text-center pa-0 mt-2 mb-6">
        <img :src="require(`@/assets/webBrand--billy-dash${ $vuetify.theme.dark ? '-wh' : ''}.svg`)" width="211">
        <span class="mt-2 d-block subtitle-1 grey-500--text font-weight-bold">Restablecer contraseña</span>
        <span class="mt-2 d-block body-1 grey-500--text">Escribe tu nueva contraseña para iniciar sesión.</span>
      </v-col>
      <span class="text-body-2 text-grey-500">Contraseña</span>
      <v-text-field class="icon-field" v-model="user.new_password1" @keyup.enter="resetPassword" :error="$v.user.new_password1.$error" @click:append="show1 = !show1" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'user.new_password1' : 'password'" outlined hide-details required single-line dense maxlength="20" autocomplete="new-password" />
      <span class="d-block mt-5 text-body-2 text-grey-500">Contraseña</span>
      <v-text-field class="icon-field" v-model="user.new_password2" @keyup.enter="resetPassword" :error="$v.user.new_password2.$error" @click:append="show = !show" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'user.new_password2' : 'password'" outlined :hide-details="$v.user.new_password2.sameAsPassword" persistent-hint required single-line dense maxlength="20" autocomplete="new-password" hint="El password debe ser igual." />
      <v-btn class="mt-13 mb-2"  @click="resetPassword" :loading="createLoader" color="blue-500" dark block>Restablecer contraseña</v-btn>
    </v-card>
  </div>
</template>
<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    user: {
      uid: null,
      token: null,
      new_password1: '',
      new_password2: ''
    },
    createLoader: false,
    show: false,
    show1: false,
    env: process.env?.VUE_APP_MODE ?? 'ax'
  }),
  created () {
    this.user.uid = this.$route.params.uid
    this.user.token = this.$route.params.token
  },
  methods: {
    resetPassword () {
      this.$v.user.$touch()
      if (this.$v.user.$invalid) {
        return false
      }
      this.createLoader = true
      this.$store.dispatch('auth/PASSWORD_RESET_CONFIRM', {
        uid: this.user.uid,
        token: this.user.token,
        new_password1: this.user.new_password1,
        new_password2: this.user.new_password2
      })
      .then(() => {
        this.$dialog.message.info('Se ha restablecido la contraseña, inicia sesión para continuar.')
        this.$router.push({ name: 'AuthSignIn' })
      })
      .finally(() => {
        this.createLoader = false
      })
    }
  },
  validations: {
    user: {
      new_password1: {
        required,
        minLength: minLength(8)
      },
      new_password2: {
        sameAsPassword: sameAs('new_password1')
      }
    }
  }
}
</script>